import { siteInfo } from '@/mocks/siteInfo';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20digital%20waves%20with%20warm%20orange%20and%20teal%20gradient%20on%20sophisticated%20dark%20background%2C%20smooth%20organic%20shapes%2C%20minimalist%20modern%20design%2C%20professional%20call%20to%20action%20visual&width=1800&height=800&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/75 to-foreground-950/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-5">
          准备好开始您的访问之旅了吗？
        </h2>
        <p className="text-base text-background-50/70 mb-8 max-w-xl mx-auto leading-relaxed">
          立即进入 {siteInfo.name}，体验稳定流畅的访问服务。数百万用户的选择，值得您的信赖。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.officialUrl}
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 cursor-pointer"
          >
            <i className="ri-rocket-line mr-2"></i>
            立即访问 17c.com
          </a>
        </div>
      </div>
    </section>
  );
}